import { DivContainer, DivContainer100 } from "common/components/divContainer";
import { Price } from "../../../../common/aypaForms/price";

interface Props {
    isLoadingEnabled: boolean
}
export const PriceMetadata = ({ isLoadingEnabled }: Props) => {

    /**Constants */
    const labelPrice = "Price";

    return (

        <DivContainer>
            <>
                <DivContainer100 label={labelPrice}>
                    <Price isLoadingEnabled={isLoadingEnabled} />
                </DivContainer100>
            </>
        </DivContainer>
    )
}